import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://a1b5e8f3d9934f808c6538151798db7d@app.glitchtip.com/6697",
  tracesSampleRate: 0.01,
});

// scripts
import "./js/scripts/navigation";
import "./js/scripts/smooth-scroll";
import "./js/scripts/blog-sidebar";
import "./js/scripts/demo-leandata-snippet-hubspot";
import "./js/scripts/flash-messages";
import "./js/scripts/download-assistant";

// blocks
import "./js/blocks/TabSwitcher";
import "./js/blocks/TestimonialSlider";
import "./js/blocks/VersionComparison";
import "./js/blocks/PageSubNavigation";
import "./js/blocks/FixedCTA";
import "./js/blocks/VideoPlayer";
import "./js/blocks/Form";
import "./js/blocks/Algolia";

document.addEventListener("DOMContentLoaded", function () {
  document.dispatchEvent(new Event("NRIScriptsLoaded"));
});
